import { TimeIntervalTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { Meridian } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { isOvernightTimeInterval } from 'src/components/oneCorp/features/MealCredit/utils/isOvernightTimeInterval';
import { isAllDayTimeInterval } from 'src/components/oneCorp/features/MealCredit/utils/isAllDayTimeInterval';

export interface CalculateTimeIntervalTypeParams {
  startTime: string;
  startTimeMeridian: Meridian;
  endTime: string;
  endTimeMeridian: Meridian;
}

export function calculateTimeIntervalType({
  startTime,
  startTimeMeridian,
  endTime,
  endTimeMeridian,
}: Partial<CalculateTimeIntervalTypeParams>): TimeIntervalTypeValues {
  const isAllDay = isAllDayTimeInterval({
    startTime,
    startTimeMeridian,
    endTime,
    endTimeMeridian,
  });
  if (isAllDay) {
    return TimeIntervalTypeValues.ALL_DAY;
  }
  const isOvernight = isOvernightTimeInterval({
    startTime,
    startTimeMeridian,
    endTime,
    endTimeMeridian,
  });
  return isOvernight
    ? TimeIntervalTypeValues.OVERNIGHT
    : TimeIntervalTypeValues.HOURS;
}
